import { render, staticRenderFns } from "./StockDetailsPrint.vue?vue&type=template&id=f478e398&"
import script from "./StockDetailsPrint.vue?vue&type=script&lang=js&"
export * from "./StockDetailsPrint.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VSheet})
